module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Medium.220843e2.woff";